import React, { useCallback, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { testMessage } from '@/api'
import { WebhookProps, MessageChannelTypes } from '@/types'
import { Row, ErrorMessage } from './components'
import Button from '@/components/Button'
import { Message } from '@cx/ui'

export interface TestChannelProps {
  type: MessageChannelTypes
  contents: WebhookProps[]
  onTestEnd?: (errors: string[]) => void
}

const TestChannel: React.FC<TestChannelProps> = (props) => {
  const { type, contents, onTestEnd } = props
  const [errorMessage, setErrorMessage] = useState<string>('')
  const { isLoading, mutate } = useMutation(testMessage, {
    onSuccess: (res) => {
      onTestEnd && onTestEnd(res?.addresses ?? [])
      if (res?.addresses?.length > 0) {
        setErrorMessage('发信失败')
      } else {
        Message.success('消息已发送')
      }
    },
  })

  const onTest = useCallback(() => {
    if (contents?.length > 0) {
      setErrorMessage('')
      mutate({ channel: type, receives: contents })
    } else {
      setErrorMessage('请设置发信测试接收人')
    }
  }, [contents, mutate, type])

  return (
    <Row sx={{ alignItems: 'center', gap: '8px' }}>
      <Button
        type='text'
        onClick={onTest}
        disabled={isLoading}
        sx={{
          padding: '0',
          backgroundColor: 'transparent !important',
          minWidth: 'auto !important',
        }}
      >
        {isLoading ? '发信中' : '发信测试'}
      </Button>
      {errorMessage?.length > 0 && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Row>
  )
}

export default TestChannel
